// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"360":"8e5433b2","430":"b7060743","498":"82d1baaa","824":"1d4dd076","864":"b7060743","986":"968f240d"}[chunkId] + ".css";
};